module.exports = __webpack_public_path__ + "img/snakebite-FAQ--3.1b40e628.jpg";